import React, { Component } from 'react';
import { Form, Icon, Input, Button, Checkbox } from 'antd';
import { message } from 'antd';
import styles from '../Form.module.css';

const { Item } = Form;

const WrappedLoginForm = Form.create()(
  class LoginForm extends Component {
    handleSubmit = e => {
      e.preventDefault();
      this.props.form.validateFields((err, values) => {
        if (!err)
          this.props
            .onLogin(values)
            .then(() => {
              message.success('Login Success', 1);
            })
            .catch(console.error);
        else return;
      });
    };

    render() {
      const { getFieldDecorator } = this.props.form;
      return (
        <Form onSubmit={this.handleSubmit} className={styles.Form}>
          <Item>
            {getFieldDecorator('email', {
              rules: [
                { type: 'email', message: 'The input is not a valid E-mail' },
                { required: true, message: 'Please input your email address' },
              ],
            })(<Input prefix={<Icon type="mail" className={styles.Input} />} placeholder="Username" />)}
          </Item>
          <Item>
            {getFieldDecorator('password', {
              rules: [{ required: true, message: 'Please input your Password!' }],
            })(<Input prefix={<Icon type="lock" className={styles.Input} />} type="password" placeholder="Password" />)}
          </Item>
          <Item>
            {getFieldDecorator('remember', {
              valuePropName: 'checked',
              initialValue: true,
            })(<Checkbox>Remember me</Checkbox>)}
            <a className={styles.Forgot} onClick={() => this.props.onTabChange('ForgotPassword')}>
              Forgot password
            </a>
            <Button type="primary" htmlType="submit" className={styles.Button}>
              Log in
            </Button>
          </Item>
        </Form>
      );
    }
  },
);

export default WrappedLoginForm;



// WEBPACK FOOTER //
// ./src/components/Forms/LoginForm/LoginForm.js